/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TimelineHistory from '../../../../../../../../components/ui-elements/timeline/TimelineHistory';
import { Typography } from '@mui/material';
import { useState } from 'react';
import { getOrgAppAuthProviderHistory } from '../../../../../../../../store/reducers/organization/orgAppAuthProvider/orgAppAuthProviderAction';

const OrgAppAuthProviderHistory = ({ selectedOrgAppAuthProvider }) => {
    const [historyList, setHistoryList] = useState([]);
    const dispatch = useDispatch()
    const orgAppAuthProviderHistory = useSelector(state => state.orgAppAuthProvider.orgAppAuthProviderHistory)
    useEffect(() => {
        dispatch(getOrgAppAuthProviderHistory({ organizationApplicationAuthProviderID: selectedOrgAppAuthProvider.organizationApplicationAuthProviderID }))

    }, [dispatch, selectedOrgAppAuthProvider]);

    useEffect(() => {
        setHistoryList([]);
        if (orgAppAuthProviderHistory?.length > 0) {
            orgAppAuthProviderHistory.forEach(element => {
                setHistoryList(item => [...item, {
                    ...element, Record: {
                        name: '',
                        details: element.Record?.organizationApplicationAuthProviderDetails,
                        createdBy: element.Record.createdBy ?? "",
                        updatedBy: element.Record.updatedBy ?? "",
                    }
                }]);
            });
        }
    }, [orgAppAuthProviderHistory]);
    return (
        <>
            <Typography variant="h3" align="center" color="success.light"> History</Typography>
            <TimelineHistory items={historyList} />
        </>
    )

}


export default OrgAppAuthProviderHistory;
